import styled from "styled-components";

const PandaVideoContainer = styled.div`
	display: flex;
`;
export { PandaVideoContainer };
